export const PARENT_SLICE_NAME = 'scheduleBuilderSchedule';

export const expectedMockState = {
  schedule: {
    id: '1',
    startDate: '2025-04-28',
    endDate: '2025-05-04',
    isJumpstartVisible: false,
    isSmsNotifyScheduleEnabled: true,
    smsDiscoverability: false,
    sortByWeek: 'first_name',
    deletedShiftsCount: 0,
    isAddShiftNotesReminderEnabled: false,
    status: 'succeeded',
    events: [
      {
        id: '3',
        type: 'event',
      },
    ],
    jobs: [
      {
        id: '1',
        type: 'job',
      },
    ],
    roles: [],
    shifts: [
      {
        id: 'shift1',
        type: 'shift',
      },
      {
        id: 'shift2',
        type: 'shift',
      },
    ],
    jobPositions: [
      {
        id: '2',
        type: 'jobPosition',
      },
    ],
    customJobPositions: [
      {
        id: '1',
        type: 'customJobPosition',
      },
    ],
    timeOffs: [],
    eventQuotas: [
      {
        id: '4',
        type: 'eventQuota',
      },
    ],
    shiftNotesQuotas: [
      {
        id: '4',
        type: 'shiftNotesQuota',
      },
    ],
    timeOffBlackoutPeriods: [],
    scheduleAvailabilities: [],
    shiftLaborTotals: [],
    locations: [],
    claimRequests: [
      {
        id: 'test-claim-req-987',
        type: 'claimRequest',
      },
    ],
    shiftNotes: [
      {
        id: 'test-shift-note-987',
        type: 'shiftNote',
      },
    ],
    shiftEvents: [
      {
        id: 'test-shift-event-987',
        type: 'shiftEvent',
      },
    ],
  },
  shifts: {
    entities: {
      shift1: {
        id: 'shift1',
        type: 'shift',
        startAt: '2025-04-11 08:00',
        endAt: '2025-04-11 17:00',
        color: 'blue',
        isOpen: false,
        isPublished: true,
        hasTimecard: false,
        affectsUnpublishedCounter: true,
        roleName: null,
        noteAttribute: undefined,
        synced: true,
        syncError: false,
        isApproved: null,
        approvalEvent: null,
        owner: { id: 'job1', type: 'job' },
        role: [],
        shiftEvents: [],
        conflict: { id: 'shift1-shift-shift2', type: 'conflict' },
        note: [],
      },
      shift2: {
        id: 'shift2',
        type: 'shift',
        startAt: '2025-04-11 09:00',
        endAt: '2025-04-11 18:00',
        color: 'blue',
        isOpen: false,
        isPublished: true,
        hasTimecard: false,
        affectsUnpublishedCounter: true,
        noteAttribute: undefined,
        roleName: null,
        synced: true,
        syncError: false,
        isApproved: null,
        approvalEvent: null,
        owner: { id: 'job1', type: 'job' },
        role: [],
        shiftEvents: [],
        conflict: { id: 'shift2-shift-shift1', type: 'conflict' },
        note: [],
      },
    },
    ids: ['shift1', 'shift2'],
    status: 'succeeded',
  },
  timeOffs: { entities: {}, ids: [], status: 'succeeded' },
  events: {
    entities: {
      '3': {
        id: '3',
        title: 'test event',
        description: 'test description',
        holiday: false,
        date: '2025-04-28',
      },
    },
    ids: ['3'],
    status: 'succeeded',
  },
  eventQuotas: {
    entities: {
      '4': {
        id: '4',
        unlimited: true,
        allowed: undefined,
        used: undefined,
        month: 4,
        year: 2025,
      },
    },
    ids: ['4'],
    status: 'succeeded',
  },
  jobPositions: {
    entities: {
      '2': { id: '2', type: 'jobPosition', position: 0 },
    },
    ids: ['2'],
    status: 'succeeded',
  },
  jobs: {
    entities: {
      '1': {
        id: '1',
        type: 'job',
        level: 'Manager',
        location: undefined,
        roleWages: undefined,
        user: undefined,
        defaultRoleId: null,
        wageRate: 19,
        scheduleConfirmation: 'not_viewed',
        ptoCategories: [
          'unpaid_time_off',
          'pto_no_policy',
          'paid_sick_leave_no_policy',
        ],
        archivedAt: null,
      },
    },
    ids: ['1'],
    status: 'succeeded',
  },
  customJobPositions: {
    entities: {
      '1': { id: '1', type: 'customJobPosition', position: 0 },
    },
    ids: ['1'],
    status: 'succeeded',
  },
  roles: { entities: {}, ids: [], status: 'succeeded' },
  roleWages: { entities: {}, ids: [], status: 'succeeded' },
  roleLaborTotals: { entities: {}, ids: [], status: 'idle' },
  laborTargets: { entities: {}, ids: [], status: 'idle' },
  publishHistoryEvents: { entities: {}, ids: [], status: 'idle' },
  reassignment: {
    entities: {},
    ids: [],
    status: 'idle',
    error: undefined,
  },
  timeOffBlackoutPeriods: {
    entities: {},
    ids: [],
    status: 'succeeded',
  },
  scheduleAvailabilities: {
    entities: {},
    ids: [],
    status: 'succeeded',
  },
  shiftLaborTotals: { entities: {}, ids: [], status: 'idle' },
  session: { id: '1', canManageEmployees: 'false', status: 'idle' },
  templates: { entities: {}, ids: [], status: 'idle' },
  locations: {
    entities: {},
    ids: [],
    status: 'idle',
    error: undefined,
  },
  users: {
    entities: {
      '1': {
        id: '1',
        type: 'user',
        firstName: 'Test',
        lastName: 'User',
        avatar: 'example.png',
      },
    },
    ids: ['1'],
    status: 'succeeded',
  },
  weatherForecast: {
    weatherForecasts: {},
    error: undefined,
    status: 'idle',
  },
  commonShifts: { entities: {}, ids: [], status: 'idle' },
  shiftNotesQuotas: {
    entities: {
      '4': {
        id: '4',
        type: 'shiftNotesQuota',
        unlimited: true,
        used: 0,
        allowed: 100,
        month: 4,
        year: 2025,
      },
    },
    ids: ['4'],
    status: 'succeeded',
  },
  properties: {
    isWageForecastVisible: false,
    isEventsVisible: false,
    isHoursForecastVisible: false,
    isPeopleForecastVisible: false,
    isScheduleUsersOnly: false,
    isSalesForecastEnabled: false,
    isWeatherForecastEnabled: false,
    isDepartmentsForecastEnabled: false,
    isWagePercentageForecastEnabled: false,
    isBudgetForecastEnabled: false,
    status: 'idle',
    error: undefined,
  },
  claimRequests: {
    entities: {
      'test-claim-req-987': {
        id: 'test-claim-req-987',
        type: 'claimRequest',
        status: 'pending',
        createdAt: '2099-12-31 23:59',
        shift: {
          id: 'test-shift-123',
          type: 'shift',
        },
        job: {
          id: 'test-job-321',
          type: 'job',
        },
      },
    },
    ids: ['test-claim-req-987'],
    status: 'succeeded',
  },
  shiftNotes: {
    entities: {
      'test-shift-note-987': {
        id: 'test-shift-note-987',
        type: 'shiftNote',
        text: 'Test shift note',
        createdAt: '2099-12-31 23:59',
        author: 'Test Author',
        shift: {
          id: 'test-shift-123',
          type: 'shift',
        },
      },
    },
    ids: ['test-shift-note-987'],
    status: 'succeeded',
  },
  shiftEvents: {
    entities: {
      'test-shift-event-987': {
        id: 'test-shift-event-987',
        type: 'shiftEvent',
        createdAt: '2099-12-31 23:59',
        userName: 'Test User',
        action: 'created',
        title: 'Shift created',
        shift: {
          id: 'test-shift-123',
          type: 'shift',
        },
      },
    },
    ids: ['test-shift-event-987'],
    status: 'succeeded',
  },
  estimatedSales: { entities: {}, ids: [], status: 'idle' },
  companyHours: { entities: {}, ids: [], status: 'idle' },
  claimRequestTotals: { entities: {}, ids: [], status: 'idle' },
  departments: { entities: {}, ids: [], status: 'idle' },
  conflicts: {
    entities: {
      'shift1-shift-shift2': {
        id: 'shift1-shift-shift2',
        type: 'conflict',
        conflictType: 'shift',
        sourceId: 'shift1',
        sourceType: 'shift',
        targetId: 'shift2',
        targetType: 'shift',
      },
      'shift2-shift-shift1': {
        id: 'shift2-shift-shift1',
        type: 'conflict',
        conflictType: 'shift',
        sourceId: 'shift2',
        sourceType: 'shift',
        targetId: 'shift1',
        targetType: 'shift',
      },
    },
    ids: ['shift1-shift-shift2', 'shift2-shift-shift1'],
    status: 'succeeded',
  },
};
